import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import I18n from 'PMT/i18n/I18n';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- utils
import DateUtils from 'PMT/utils/DateUtils';
import classNames from 'classnames';
import Utils from 'PMT/utils/Utils';

// -- stores
import SessionStore from 'stores/SessionStore';

// -- entities
import Timelapse from 'PMT/entities/Timelapse';

// -- views
import DateTimeField from 'react-datetime';
import Calendar from 'PMT/components/Calendar';

/**
 * Display a picker that allows to choose a timelapse. There is four main choices:
 * - day
 * - week
 * - month
 * - custom
 *
 * Docs:
 * - http://momentjs.com/docs/#/manipulating/add/
 */
class TimelapsePicker extends Component {

  static propTypes = {
    timelapse: PropTypes.instanceOf(Timelapse).isRequired,
    onTimelapseChange: PropTypes.func.isRequired,

    className: PropTypes.string,
    popinMode: PropTypes.bool,

    /**
     * The current item menu selected as timelapse.
     * @type ViewsConstants.Timelapse.Selection
     */
    timelapseSelection: PropTypes.number,

    futureMode: PropTypes.bool,

    onTimelapseSelectionChanged: PropTypes.func
  };

  static defaultProps = {
    popinMode: false,

    futureMode: false,

    timelapseSelection: null,

    // param: ViewConstants.Timelapse.Selection
    onTimelapseSelectionChanged: null
  };

  state = {
    fromTime: this.defaultFromTime,
    toTime: this.defaultToTime,

    id: Utils.generateUID(),

    displayPickers: false
  };

  get defaultFromTime() {
    return this.props.timelapse.getFromTime() === -1 ?
     DateUtils.getTimelapseMonthInterval().getFromTimeAsDate()
    : this.props.timelapse.getFromTimeAsDate();
  }

  get defaultToTime() {
    return this.props.timelapse.getToTime() === -1 ?
     DateUtils.getTimelapseMonthInterval().getToTimeAsDate()
    : this.props.timelapse.getToTimeAsDate();
  }

  // -- Events

  onSelectDayInterval = (event) => {
    event.preventDefault();

    if (!_.isNull(this.props.onTimelapseSelectionChanged)) {
      this.props.onTimelapseSelectionChanged(ViewConstants.Timelapse.Selection.DAY);
    } else { // default: we save the selection as the global timelapse selection
      SessionStore.saveTimelapseSelection(ViewConstants.Timelapse.Selection.DAY);
    }
    let timelapse: Timelapse;
    if (this.props.futureMode) {
      timelapse = DateUtils.getTimelapseDayInterval();
    } else {
      timelapse = DateUtils.getTimelapseDayInterval();
    }
    this.props.onTimelapseChange(timelapse);
    this.onToggle();
  };

  onSelectWeekInterval = (event) => {
    event.preventDefault();

    if (!_.isNull(this.props.onTimelapseSelectionChanged)) {
      this.props.onTimelapseSelectionChanged(ViewConstants.Timelapse.Selection.WEEK);
    } else { // default: we save the selection as the global timelapse selection
      SessionStore.saveTimelapseSelection(ViewConstants.Timelapse.Selection.WEEK);
    }
    let timelapse: Timelapse;
    if (this.props.futureMode) {
      timelapse = DateUtils.getTimelapseWeekIntervalInFuture();
    } else {
      timelapse = DateUtils.getTimelapseWeekInterval();
    }
    this.props.onTimelapseChange(timelapse);
    this.onToggle();
  };

  onSelectMonthInterval = (event) => {
    event.preventDefault();

    if (!_.isNull(this.props.onTimelapseSelectionChanged)) {
      this.props.onTimelapseSelectionChanged(ViewConstants.Timelapse.Selection.MONTH);
    } else { // default: we save the selection as the global timelapse selection
      SessionStore.saveTimelapseSelection(ViewConstants.Timelapse.Selection.MONTH);
    }
    let timelapse: Timelapse;
    if (this.props.futureMode) {
      timelapse = DateUtils.getTimelapseMonthIntervalInFuture();
    } else {
      timelapse = DateUtils.getTimelapseMonthInterval();
    }
    this.props.onTimelapseChange(timelapse);
    this.onToggle();
  };

  onFromTimeChange = (fromTime: Object) => {
    this.setState({
      fromTime: fromTime.startOf('day')
    });
  };

  onToTimeChange = (toTime: Object) => {
    this.setState({
      toTime: toTime.endOf('day')
    });
  };

  onToggle = () => {
    $(`#${this.state.id}`).parent().toggleClass('open');
  };

  validatePersonalize = () => {
    const fromTime = this.state.fromTime;
    const toTime = this.state.toTime;

    SessionStore.saveTimelapseSelection(ViewConstants.Timelapse.Selection.CUSTOM);

    const timelapse:Timelapse = new Timelapse();

    timelapse.setFromTime(fromTime.startOf('day').unix());
    timelapse.setToTime(toTime.endOf('day').unix());

    this.props.onTimelapseChange(timelapse);

    this.onToggle();
  };

  // -- Tools

  /**
   *
   * @param type ViewConstants.Timelapse.Selection
   * @returns {boolean}
   */
  isCurrent(type: number): boolean {
    const timelapseSelection = this.props.timelapseSelection;
    return type === timelapseSelection;
  }

  // -- renderers

  renderPickers() {
    const fromTime = this.state.fromTime;
    const toTime = this.state.toTime;

    if (this.state.displayPickers === false) {
      return (null);
    }

    return (
      <div className="row" id="daterange">

        <div className="col-xs-12">
          <Calendar
            defaultDate={fromTime}
            minDate={moment().subtract(10, 'years')}
            maxDate={toTime.isBefore(moment()) ? toTime : moment()}
            onChange={this.onFromTimeChange}
          />

        </div>
        <div className="col-xs-12">
          <Calendar
            defaultDate={toTime}
            minDate={fromTime}
            maxDate={moment()}
            onChange={this.onToTimeChange}
          />

        </div>

        <div className="col-xs-12">
          <button
            className="btn btn-primary"
            onClick={this.validatePersonalize}
          >
            {I18n.tr('components.timelapse.picker.validate')}
          </button>
        </div>

      </div>
    );
  }

  render(): Object {
    const timelapse:Timelapse = this.props.timelapse;

    const className = classNames('form-inline timelapse_picker', this.props.className, {
      selected: this.props.popinMode
    });

    return (
      <div className={className}>
        <div className="dropdown dropdown-accordion">

          <label className="col-xs-4">
            {I18n.tr('components.timelapse.picker.period')}
          </label>

          <button
            onClick={this.onToggle}
            id={this.state.id}
            className="btn btn-default btn-dropdown col-xs-8"
          >

            <span
              className="fromTime"
            >
              {timelapse.getFromTimeAsFormattedDate()}
            </span>
            <span> - </span>
            <span className="toTime">{timelapse.getToTimeAsFormattedDate()}</span>
            <span className="caret" />
          </button>

          <ul
            className="timelapse-menu dropdown-menu dropdown-menu-right col-xs-8"
            role="menu"
          >
            <li
              className={this.isCurrent(ViewConstants.Timelapse.Selection.DAY) ? 'timelapse_current' : ''}
            >
              <a
                href="#"
                onClick={this.onSelectDayInterval}
              >
                {I18n.tr('components.timelapse.picker.day')}
              </a>
            </li>
            <li className={this.isCurrent(ViewConstants.Timelapse.Selection.WEEK) ? 'timelapse_current' : ''}>
              <a
                href="#"
                onClick={this.onSelectWeekInterval}
              >
                {I18n.tr('components.timelapse.picker.week')}
              </a>
            </li>
            <li className={this.isCurrent(ViewConstants.Timelapse.Selection.MONTH) ? 'timelapse_current' : ''}>
              <a
                href="#"
                onClick={this.onSelectMonthInterval}
              >
                {I18n.tr('components.timelapse.picker.month')}
              </a>
            </li>

            <li>

              <a
                className="pointer"
                onClick={ () => { this.setState({ displayPickers: !this.state.displayPickers }) }}
              >
                {I18n.tr('components.timelapse.picker.custom')}
              </a>

              {this.renderPickers()}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default TimelapsePicker;
